export default __webpack_public_path__ + "src/images/packages/oceana-reserve/f59425b1f61e11acb31c1f9405f5b11a-5.jpg";